import { useEffect } from "react";

import {
	clearInbox,
	releaseInboxScope,
	setCurrentLeadIndex,
} from "@/pages/Private/redux/list/list.slice";
import { useAppDispatch } from "@/redux/hooks";
import { GetUnassignedListRequestPaginationParams } from "@/pages/Private/pages/List/schema/list";

import { BuilderPreviewInput, buildBuilderPreviewRequest } from "./builderPreviewRequest.util";

/**
 * The campaign builder's lead panel (extracted from CampaignPage). Each activation clears the panel
 * with the request as its active scope, so only that request's answer fills it, then triggers it
 * (PREC-4790 r1). When the builder closes, the scope is released: a builder answer still in flight
 * then falls under the latest-request rule and cannot replace the rows of the surface opened next,
 * such as the list's ordinary lead table (PREC-4790 review r2 M2).
 */
export const useBuilderPreviewInbox = (
	{ page, limit, query, sorting, listId, filter }: BuilderPreviewInput,
	getUnassigned: (request: GetUnassignedListRequestPaginationParams) => unknown
): void => {
	const dispatch = useAppDispatch();

	useEffect(() => {
		const request = buildBuilderPreviewRequest({ page, limit, query, sorting, listId, filter });

		dispatch(clearInbox(request));
		dispatch(setCurrentLeadIndex(0));
		getUnassigned(request);
	}, [dispatch, filter, getUnassigned, listId, limit, page, query, sorting]);

	useEffect(
		() => () => {
			dispatch(releaseInboxScope());
		},
		[dispatch]
	);
};
